import { createContext } from "react";
import { Config } from "./types";

export const Context = createContext<Config | null>(null);
